import { dispatch } from '@pressreader/appstore';

import { currentWindowActivated } from './store';

const CHECK_HEARTBEAT_INTERVAL = 60 * 1000; // 1 minute
const INACTIVITY_THRESHOLD = 5 * 60 * 1000; // 5 minutes

let lastActiveAt = Date.now();
let initialized = false;

// Mark activity on useful events
function markActivity() {
    lastActiveAt = Date.now();
}

function refreshIfInactive() {
    const now = Date.now();
    const inactiveDuration = now - lastActiveAt;

    if (inactiveDuration > INACTIVITY_THRESHOLD) {
        // Detected inactivity:
        dispatch(currentWindowActivated());
        lastActiveAt = now; // reset after refresh
        return true;
    }
    return false;
}

function updateActivity() {
    const updated = refreshIfInactive();
    if (!updated) {
        markActivity();
    }
}

function initHeartBeatSystem() {
    if (initialized) {
        return;
    }
    initialized = true;
    // Page/tab lifecycle
    document.addEventListener('visibilitychange', () => {
        if (!document.hidden) {
            updateActivity();
        }
    });
    window.addEventListener('focus', updateActivity);
    window.addEventListener('pageshow', updateActivity);

    // User activity (optional, improves accuracy)
    ['mousemove', 'keydown', 'scroll', 'click'].forEach(evt => window.addEventListener(evt, markActivity, { passive: true }));

    // Heartbeat check (runs even if tab is still visible)
    window.setInterval(refreshIfInactive, CHECK_HEARTBEAT_INTERVAL);
}

export { initHeartBeatSystem };
